import { makeStyles } from "@material-ui/styles";
// import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  minFormControl:{
    minHeight:112
  },
  upload_content:{
    marginTop:45,
  },
  wrapper:{
    marginTop:40
  },
  margin:{
    padding:'5px 5px 5px 5px'
  },
  labelStyle:{
    transform: 'translate(0px, 8px) scale(1)'
  },
  root:{
    width:"100%"
  },
  container: {
    height: "100vh",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    position: "absolute",
    top: 0,
    left: 0,
  },
  form_control:{
    width:"100%",
  },
  text_root:{
    paddingRight:0,
  },
  adornedEnd:{
    paddingRight:0,
  },
  logotypeContainer: {
    backgroundColor: theme.palette.primary.main,
    width: "60%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  logotypeImage: {
    width: 165,
    marginBottom: 32,
  },
  logotypeText: {
    color: "white",
    fontWeight: 500,
    fontSize: 84,
    [theme.breakpoints.down("md")]: {
      fontSize: 48,
    },
  },
  formContainer: {
    // width: "40%",
    height: "100%",
    display: "flex",
    paddingTop:80,
    flexDirection: "column",
    // justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      width: "50%",
    },
  },
  form: {
    // width: 320,
  },
  tab: {
    fontWeight: 400,
    fontSize: 18,
  },
  greeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: 32,
  },
  subGreeting: {
    fontWeight: 500,
    textAlign: "center",
    marginTop: 16,
  },
  googleButton: {
    marginTop: 16,
    boxShadow: theme.customShadows.widget,
    backgroundColor: "white",
    width: "100%",
    textTransform: "none",
  },
  googleButtonCreating: {
    marginTop: 0,
  },
  googleIcon: {
    width: 30,
    marginRight: 16,
  },
  creatingButtonContainer: {
    marginTop: 20,
    height: 46,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  createAccountButton: {
    height: 46,
    textTransform: "none",
  },
  formDividerContainer: {
    marginTop: 32,
    marginBottom: 32,
    display: "flex",
    alignItems: "center",
  },
  formDividerWord: {
    paddingLeft: 16,
    paddingRight: 16,
  },
  formDivider: {
    flexGrow: 1,
    height: 1,
    backgroundColor: theme.palette.text.hint + "40",
  },
  errorMessage: {
    textAlign: "center",
  },
  textFieldUnderline: {
    "&:before": {
      borderBottomColor: theme.palette.primary.light,
    },
    "&:after": {
      borderBottomColor: theme.palette.primary.main,
    },
    "&:hover:before": {
      borderBottomColor: `${theme.palette.primary.light} !important`,
    },
  },
  textField: {
    borderBottomColor: theme.palette.background.light,
  },
  formButtons: {
    width: "100%",
    marginTop: 32,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  forgetButton: {
    textTransform: "none",
    fontWeight: 400,
  },
  loginLoader: {
    marginLeft: 32,
  },
  copyright: {
    marginTop: 32,
    whiteSpace: "nowrap",
    [theme.breakpoints.up("md")]: {
      position: "absolute",
      bottom: 16,
    },
  },
  verifCode: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  sendBtn: {
    width: "100px",
    marginTop: "16px",
    marginBottom: "8px",
  },
}));
